import { icon, Icon } from '../lib/fa-icons.js';
import Widget from "./base.js";

// Normalize slugs for comparison: the legacy Brevo lists use underscores
// (the_backchannel) while editorial-newsletter rows use hyphens
// (the-backchannel). Match either convention so the widget works pre- and
// post-beehiiv-switchover.
const slugMatch = (a, b) => (a ?? "").replace(/[-_]/g, "-") === (b ?? "").replace(/[-_]/g, "-");

export class NewslettersWidget extends Widget {
	componentWillMount() {
		this.handleEmail = this.handleEmail.bind(this);
		this.handleCheckbox = this.handleCheckbox.bind(this);
		this.getData();
	}

	componentDidMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const addToMultipleLists = urlParams.get("addToMultipleLists");
		if (addToMultipleLists) {
			this.postData({ addToMultipleLists });
		}
	}

	clearErrors() {
		this.setState({ errors: null });
	}

	getData() {
		this.request("GET");
	}

	postData(opts) {
		this.clearErrors();
		this.request("POST", opts);
	}

	request(method, data = {}) {
		const self = this;

		let params = `?`;
		Object.keys(data).forEach((k) => {
			params += `${k}=${data[k]}&`;
		});

		fetch(
			`https://accounts.${document.location.hostname}/doesspress/email-list${params}`,
			{
				method: `${method}`,
				credentials: "include",
			}
		)
			.then((r) => {
				return r.json();
			})
			.then((r) => {
				if (method === "GET") {
					self.setState({
						emailLists: r.bindings.emailLists,
						ident: r.bindings.ident,
					});
				} else {
					if (r.errors) {
						self.setState({ error: r.errors[0] });
					}
					if (r.confirmation) {
						/* 
            if the user has just signed in and has an addToMultipleLists query param, we want to refresh the page
            after the email prefs are updated.

            this is hacky and dumb, but it lets us not worry about re-rending the form UI in response to ajax requests.
            if this form gets any more complex, change this and refactor how the doesspress/email-list endpoint works
             */
						if (
							r.confirmation.key !== "list_pref_create_account" &&
							data.addToMultipleLists
						) {
							window.location =
								window.location.origin + window.location.pathname;
						}
						self.setState({ confirmation: r.confirmation });
					}
				}
			});
	}

	handleCheckbox(e) {
		const signedIn = this.state.ident.id;
		if (!signedIn) return;

		const opts = {
			listId: e.target.parentElement.querySelector('input[name="listId"]')
				.value,
		};
		//only set this if checkbox is checked, send nothing otherwise
		if (e.target.checked) opts.addToList = true;

		this.postData(opts);
	}

	handleEmail(e) {
		e.preventDefault();

		const checkedInputs = document.querySelectorAll(
			".NewslettersLanding__Checkbox:checked"
		);
		if (checkedInputs.length === 0) {
			this.setState({
				error: { message: "Please select a newsletter to subscribe to" },
			});
			return;
		} else {
			this.setState({
				error: null,
			});
		}

		const listIds = Array.from(checkedInputs).map(
			(input) => input.parentElement.querySelector('input[name="listId"]').value
		);

		const opts = {
			addToMultipleLists: listIds.join(","),
			email: document.querySelector("#newEmail").value,
		};

		this.postData(opts);
	}

	renderSection(
		options = {
			list,
			permalink,
			archiveUrl,
			description,
			isWhereThingsStand,
			isMorningMemo,
		}
	) {
		const {
			list,
			permalink,
			archiveUrl,
			description,
			isWhereThingsStand,
			isMorningMemo,
		} = options;

	const isFreeBackChannel =
		list &&
		slugMatch(list.slug, "the_backchannel") &&
		this.state.ident.membership === "none";

	let listName = "";
	if (isMorningMemo) listName = "The Morning Memo";
	else if (isWhereThingsStand) listName = "Where Things Stand";
	else if (list) listName = list.name;

		return (
			<section class="NewslettersLanding__Section">
				<a href={archiveUrl} class="NewslettersLanding__SectionHeading">
					{listName}
					{isFreeBackChannel && (
						<span class="NewslettersLanding__FreeEdition">Free Edition</span>
					)}
				</a>
				<p>{description ? description : list.description}</p>
				<div class="NewslettersLanding__SectionLinks">
					{permalink && (
						<a href={permalink} class="NewslettersLanding__Read">
							Read the latest
						</a>
					)}

					{isMorningMemo && (
						<a
							class="NewslettersLanding__SignUp --wide --no-border"
							href="https://morningmemo.talkingpointsmemo.com/"
						>
							Subscription options <Icon name="arrow-right-long" style="solid" />
						</a>
					)}

					{isWhereThingsStand && (
						<a
							class="NewslettersLanding__SignUp --wide --no-border"
							href="https://wherethingsstand.talkingpointsmemo.com/"
						>
							Subscription options <Icon name="arrow-right-long" style="solid" />
						</a>
					)}

					{!isMorningMemo && !isWhereThingsStand && this.renderForm(list)}
				</div>
			</section>
		);
	}

	renderForm(list) {
		if (!list) return null;
		const signedIn = this.state.ident.id;
		const checkedText = signedIn ? "Subscribed" : "Selected";
		const uncheckedText = signedIn ? "Subscribe" : "Select";

		return (
			<div>
				<input
					className="NewslettersLanding__Checkbox"
					id={`id_${list.id}`}
					name="addToList"
					type="checkbox"
					defaultChecked={list.subscribed}
					style={{ display: "none" }}
					onChange={this.handleCheckbox}
				/>
				<div class={`NewslettersLanding__SignUp`} key={Math.random()}>
					<label for={`id_${list.id}`}>
						<input type="hidden" name="listId" value={list.id} />
						<span class="checked">
							<Icon name="circle-check" style="light" /> {checkedText}
						</span>
						<span class="unchecked">
							<Icon name="plus" style="light" /> {uncheckedText}
						</span>
					</label>
				</div>
			</div>
		);
	}

	renderEmailForm() {
		return (
			<div className="NewslettersLanding__Form">
				<label for="email">Enter Email Address</label>
				<div className="NewslettersLanding__FormInner">
					<input
						type="email"
						id="newEmail"
						pattern=".+@example\.com"
						required
					/>

					<div className="Button --red" onClick={this.handleEmail}>
						Subscribe
					</div>
				</div>
				<p className="NewslettersLanding__FormDisclaimer">
					By signing up you agree to our <a href="/privacy">Privacy Policy</a>{" "}
					and <a href="/terms-of-use">Terms of Use</a> and to receive email
					communications from TPM. You can unsubscribe at any time.
				</p>
			</div>
		);
	}

	renderContent() {
		if (this.state.error && !this.state.emailLists)
			return <div>Something went wrong</div>;
		if (!this.state.emailLists) return <div>Loading...</div>;

		const { props } = this;

		const lists = this.state.emailLists;
		const signedIn = this.state.ident.id;
		const isMember = this.state.ident.membership !== "none";

	const weekender = lists.find((list) => slugMatch(list.slug, "the_weekender"));
	const backchannel = lists.find((list) => slugMatch(list.slug, "the_backchannel"));
	const franchise = lists.find((list) => slugMatch(list.slug, "the_franchise"));

		const confirmAcctCreation = this.state.confirmation && !signedIn;

		return (
			<div>
				{confirmAcctCreation && (
					<div>
						<h3 style={{ margin: "0" }}>Email sent!</h3>
						<p style={{ margin: "0.5em 0" }}>
							{this.state.confirmation.message}
						</p>
						<p style={{ margin: "0.5em 0" }}>
							Don’t see an email? Please check your spam folder or{" "}
							<a
								href="https://talkingpointsmemo.com/contact"
								style={{ color: "#990000" }}
							>
								contact&nbsp;us
							</a>{" "}
							for assistance.
						</p>
					</div>
				)}
				{!confirmAcctCreation && !signedIn && this.renderEmailForm()}
				{this.state.error && (
					<p
						style={{
							fontWeight: "bold",
							background: "#f5cad0",
							color: "#ff0000",
							padding: "16px",
							borderRadius: "6px",
						}}
					>
						{this.state.error.message}
					</p>
				)}
				{this.renderSection({
					list: backchannel,
					permalink: props.backchannelpermalink,
					archiveUrl: "/newsletter/category/backchannel",
					description: isMember ? (
						<span>
							<b>Josh Marshall's</b> direct line for insight, analysis, and
							conversation. TPM members receive one must-read from Josh
							delivered daily to their inbox.
						</span>
					) : (
						<span>
							<b>Josh Marshall's</b> direct line for insight, analysis, and
							conversation. The free edition includes one must-read from Josh
							Marshall delivered weekly to your inbox.{" "}
							<a href="/memberships" style={{ color: "#990000" }}>
								JOIN HERE
							</a>{" "}
							to receive the daily, member edition.
						</span>
					),
				})}
				{this.renderSection({
					list: weekender,
					permalink: props.weekenderpermalink,
					archiveUrl: "the-weekender",
					description: (
						<span>
							Unpack the funny, surreal, and strange in U.S. politics and culture with <b>Allegra Kirkland, Derick Dirmaier and the TPM team</b>.
						</span>
					),
				})}

				{this.renderSection({
					list: franchise,
					permalink: props.franchisepermalink,
					archiveUrl: "the-franchise",
					description: (
						<span>
							What you need to know about the assault on voting rights and
							democracy in America, brought to you weekly by TPM reporter{" "}
							<b>Khaya Himmelman</b>.
						</span>
					),
				})}

				{this.renderSection({
					permalink: props.morningmemopermalink,
					archiveUrl: "https://morningmemo.talkingpointsmemo.com/",
					description: (
						<span>
							<b>David Kurtz</b> brings you the essential political roundup each
							weekday morning.
						</span>
					),
					isMorningMemo: true,
				})}

				{this.renderSection({
					permalink: props.wherethingsstandpermalink,
					archiveUrl: "https://wherethingsstand.talkingpointsmemo.com/",
					description: (
						<span>
							Your TPM evening briefing from <b>Nicole Lafond</b>.
						</span>
					),
					isWhereThingsStand: true,
				})}
			</div>
		);
	}
}
